import config from '@/config'
import { Route } from '@/contracts/core/api/entity/Route'

/** Маршруты модуля sync: работать ли без сервера, решает настройка модуля в src/config.ts */
export abstract class SyncRoute<P, T> extends Route<P, T> {
  isOffline(): boolean {
    return config.systemModules.sync.offline === 'true'
  }
}
